export default __webpack_public_path__ + "static/kenya-0ab398b69ec0236e602ae111c9564032.jpg";